// src/app/redux/reducers/candidatsReducer.js
import {
    SET_CANDIDATS_LOADING,
    SET_CANDIDATS_ERROR,
    FETCH_CANDIDATS_REQUEST,
    FETCH_CANDIDATS_SUCCESS,
    FETCH_CANDIDATS_FAIL,
    CREATE_CANDIDAT_SUCCESS,
    CREATE_CANDIDAT_FAIL,
    UPDATE_CANDIDAT_SUCCESS,
    UPDATE_CANDIDAT_FAIL,
    DELETE_CANDIDAT_SUCCESS,
    DELETE_CANDIDAT_FAIL,
} from "../actions/candidatsActions";

const initialState = {
    loading: false,
    error: null,
    candidats: [],
};

export default function candidatsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CANDIDATS_LOADING:
            return { ...state, loading: !!action.payload };

        case SET_CANDIDATS_ERROR:
            return { ...state, error: action.payload };

        case FETCH_CANDIDATS_REQUEST:
            return { ...state, error: null };

        case FETCH_CANDIDATS_SUCCESS:
            return { ...state, candidats: action.payload || [], error: null };

        case FETCH_CANDIDATS_FAIL:
        case CREATE_CANDIDAT_FAIL:
        case UPDATE_CANDIDAT_FAIL:
        case DELETE_CANDIDAT_FAIL:
            return { ...state, error: action.payload };

        case CREATE_CANDIDAT_SUCCESS:
        case UPDATE_CANDIDAT_SUCCESS:
            // comme tes autres modules: on laisse saga refetch
            return { ...state, error: null };

        case DELETE_CANDIDAT_SUCCESS:
            return {
                ...state,
                candidats: (state.candidats || []).filter((x) => x.id !== action.payload),
                error: null,
            };

        default:
            return state;
    }
}
